<template>
  <v-dialog
    :value="value"
    @input="$emit('input')"
    max-width="500px"
    persistent
    content-class="ims-standard-dialog"
  >
    <v-card class="ims-modal-card">
      <v-card-title class="title ims-modal-header">
        <span>Release Brief Checklist</span>
        <v-spacer></v-spacer>
        <v-btn icon color="secondary" aria-label="Close" title="Close" @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="body-2 ims-modal-body" style="padding-top:30px">
        <div>
          <p class="subtitle-1 font-weight-bold mb-2">Please check and confirm these steps below</p>
          <ol class="text-left body-1">
            <li>The brief uses clear language to lead and guide stakeholders' interpretation.</li>
            <li>The brief is aligned with audience-first approach.</li>
            <li>The brief is aligned with content best practices.</li>
          </ol>
        </div>
      </v-card-text>
      <v-card-actions class="ims-modal-actions">
        <v-btn color="secondary" id="close" text @click.native="close()">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save()">Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'BriefReleaseChecklistModal',
  props: {
    value: Boolean,
    campaign: Object
  },
  components: {
  },
  data () {
    return {
    }
  },
  async mounted() {
  },
  methods: {
    save() {
      // save func
      this.close()
      this.$emit('confirmActivate', this.campaign.id)
    },
    close() {
      this.$emit('input')
    }
  }
};
</script>
<style scoped>
  .edit-date-box {
    max-width: 200px;
  }
  .date-picker-inner {
    margin-left: -35px;
    padding-top: 3px;
  }
</style>



// WEBPACK FOOTER //
// BriefReleaseChecklistModal.vue?0e518992